import { useAgoFormatter } from "./use-ago-formatter";

export function DateAgoFormatter({ value }: { value: Date | string }) {
  const ago = useAgoFormatter(value);
  return <span>{ago}</span>;
}
